import React from 'react'

// Styles
import './toast.scss';

export interface ToastProps {
    text: string;
    style?: string;
}

export const Toast: React.FC<ToastProps> = (props: ToastProps) => {
    return (
        <div className={`cfm-toast cfm-toast-${props.style ? props.style : ''} `}><p dangerouslySetInnerHTML={{ __html: props.text }} /></div>
    )
}
